export const vaccinationStatusMap = {
  fullyVaccinated: 'FULLY_VACCINATED',
  notVaccinated: 'NOT_VACCINATED',
  preferNotToSay: 'PREFER_NOT_TO_ANSWER',
}

export const FULLY_VACCINATED_STATUS = 'FULLY_VACCINATED'
export const NOT_VACCINATED_STATUS = 'NOT_VACCINATED'
export const PREFER_NOT_TO_ANSWER_VACCINATED_STATUS = 'PREFER_NOT_TO_ANSWER'
